import { OperationGroup, OperationType } from '../field-matching.model';
import axios from '../../../services/axios';

import { ViewOptions } from '../components/ViewOptionsDropdown/view-options-dropdown.constants';
import { AxiosResponse } from 'axios';

export type FieldsOperationsResponse = {
  data?: OperationGroup[];
  pagination: {
    size: number;
    next_token: string;
    prev_pagination_token: string;
    return_count: number;
    total_count: number;
  };
};

export type FieldsOperationsQueryParams = {
  orgId: string;
  viewOption?: ViewOptions;
  sort?: {
    sort_by: string;
    order: string;
  };
  queryFilters?: Partial<{ operationTypes: OperationType[]; start_date: string; end_date: string }>;
  nextPageToken?: string;
  excludeSourceGeometry?: boolean;
};

const BASE_API_URL = import.meta.env.VITE_APP_API_URL;
export const PAGE_SIZE = 10;

export const getFieldsOperations = async ({
  viewOption: group_by,
  sort,
  queryFilters,
  orgId,
  nextPageToken,
  excludeSourceGeometry,
}: FieldsOperationsQueryParams): Promise<AxiosResponse<FieldsOperationsResponse>> => {
  return axios.post(`${BASE_API_URL}/opensearch/v3/unallocated-operations/query`, {
    org_id: orgId,
    group_by,
    sort,
    filters: queryFilters,
    pagination: {
      size: PAGE_SIZE,
      token: nextPageToken,
    },
    exclude_source_geometry: excludeSourceGeometry,
  });
};
